import type { ReactNode } from "react";
import { PageHeader } from "@/components/page-header";
import { cn } from "@/lib/utils";

/**
 * Standard page shell: one `h1` header, then the content with one spacing scale.
 * `narrow` is for form pages, `full` for lists and grids.
 */
export function Page({
  title,
  description,
  actions,
  width = "full",
  children,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  width?: "full" | "narrow";
  children?: ReactNode;
}) {
  return (
    <div className={cn("min-w-0", width === "narrow" && "max-w-2xl")}>
      <PageHeader title={title} description={description} actions={actions} />
      {children ? <div className="grid gap-6">{children}</div> : null}
    </div>
  );
}
